import React from 'react';
import PropTypes from 'prop-types';
import Text from 'relements/build/esm/input/text';
import Checkbox from 'relements/build/esm/input/checkbox';

import './TaskBody.scss';
import useForm from '../../../../hooks/useForm';

const INPUTS = [
  {
    label: 'Menu Option Title',
    key: 'name',
    component: Text,
    permission: 'mogambo_business_task_edit_transfer',
  },
  {
    label: 'User Messages',
    key: 'message',
    component: Text,
    permission: 'mogambo_business_task_edit_transfer',
  },
  {
    label: 'FORCE_BREAK',
    key: 'forceBreak1',
    component: () => <div style={{ minWidth: '100%' }} />,
    permission: 'mogambo_business_task_edit_transfer',
  },
  {
    label: 'Location Required',
    key: 'location_required',
    className: 'checkbox',
    component: Checkbox.Item,
    permission: 'mogambo_business_task_edit_transfer',
  },
  {
    label: 'Visible on Menu',
    key: 'is_taskbox_supported',
    className: 'checkbox',
    component: Checkbox.Item,
    permission: 'mogambo_business_task_edit_transfer',
  },
];

export default function TaskBody({ value, onChange, meta = {} }) {
  const [, getInputProps] = useForm(value, { meta, onChange });
  return (
    <div className="business-tasks-list-item-body">
      <div className="business-tasks-list-item-body-title">Configure Menu</div>
      <div className="business-tasks-list-item-body-row">
        {INPUTS.map((input) => {
          const Input = input.component;
          const inputProps = getInputProps(input);
          return (
            <Input
              {...inputProps}
              className={`${input.className} business-tasks-list-item-body-input`}
            />
          );
        })}
      </div>
    </div>
  );
}

TaskBody.propTypes = {
  meta: PropTypes.object,
  onChange: PropTypes.func,
  value: PropTypes.object,
};

TaskBody.defaultProps = {
  meta: {},
  onChange: () => {},
  value: {},
};
